<script lang="ts">
    import { Component } from 'vue-facing-decorator';
    import Vue from "vue";
    import { boolCompare } from "@common/Common";
    import { AlternativeReadModel } from "@Evaluation/Estimations/Domain/readmodels";

    @Component({
        props: {
            CorrelationId: String,
            Title: String,
            Alternatives: Array,
            SelectedAlternativesIds: Array
        }        
    })
    export default class PanelistAlternativesSelector extends Vue
    {
        alternatives: AlternativeVM[] = null;

        get alternativesView(): AlternativeVM[] 
        {
            return this.alternatives?.sort((a, b) => boolCompare(a.Included, b.Included));
        }

        mounted()
        {
            const selectedIds: number[] = this.$props.SelectedAlternativesIds ?? [];
            this.alternatives = (this.$props.Alternatives as AlternativeReadModel[]).map(a => new AlternativeVM(a, selectedIds.indexOf(a.AlternativeId) > -1));
        }
        
        confirm()
        {
            this.$emit('confirm', {
                CorrelationId: this.$props.CorrelationId,
                SelectedIds: this.alternatives.filter(a => a.Included === true).map(a => a.AlternativeId),
            });
        }

        close()
        {
            this.$emit('close');
        }
    }


    class AlternativeVM
    {
        AlternativeId: number;
        Name: string;
        Included: boolean;

        constructor(a: AlternativeReadModel, included: boolean)
        {
            this.AlternativeId = a.AlternativeId;
            this.Name = a.Name;
            this.Included = included;
        }

        toggleIncluded()
        {
            this.Included = !this.Included;
        }
    }

</script>

<template>

    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-xl modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{Title}}</h5>
                        <button @click="close" type="button" class="close">&times;</button>
                    </div>

                    <div class="modal-body">

                        <div class="list-group">
                            <button type="button" v-for="a in alternativesView" :key="a.AlternativeId" @click="a.toggleIncluded()" class="list-group-item list-group-item-action">
                                <span v-if="a.Included" class="fa-regular fa-square-check"></span>
                                <span v-if="!a.Included" class="fa-regular fa-square"></span>
                                <span>{{a.Name}}</span>
                            </button>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button @click="confirm" type="button" class="btn btn-primary">Confirm</button>
                        <button @click="close" type="button" class="btn btn-outline-secondary">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<style scoped>
</style>